import { cva } from 'class-variance-authority';

/** The size is the caller's; the default suits a bar. */
export const brandMarkStyles = cva('brand-mark inline-block size-6 shrink-0');
